const eventSettings = {
  maxLengthTittle: 25,
  maxEventPerDay: 2,
};

export default eventSettings;
